import DashboardOrders from "./dashboard_orders";
import DashboardContact from "./dashboard_contact";
function Dashboard() {
  return (
    <div className="bg-white w-full rounded-md p-4 flex flex-col gap-4">
      <DashboardOrders />
      <DashboardContact />
    </div>
  );
}

export default Dashboard;
